import React, { useState, useEffect } from 'react';
import { dashboardAPI } from '../services/api';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';

export default function Dashboard() {
  const [stats, setStats] = useState(null);
  const [reports, setReports] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadData();
  }, []);

  const loadData = async () => {
    try {
      const [statsRes, reportsRes] = await Promise.all([
        dashboardAPI.getStats(),
        dashboardAPI.getReports(),
      ]);
      setStats(statsRes.data);
      setReports(reportsRes.data);
    } catch (error) {
      console.log('Error:', error);
    } finally {
      setLoading(false);
    }
  };

  if (loading) return <div className="loading">جاري التحميل...</div>;

  return (
    <div className="dashboard">
      <h2>نظرة عامة</h2>

      <div className="stat-cards">
        <div className="stat-card blue">
          <span className="stat-icon">👥</span>
          <div>
            <h3>{stats?.totalCustomers || 0}</h3>
            <p>إجمالي العملاء</p>
          </div>
        </div>
        <div className="stat-card green">
          <span className="stat-icon">🔧</span>
          <div>
            <h3>{stats?.totalWorkers || 0}</h3>
            <p>إجمالي العمال</p>
          </div>
        </div>
        <div className="stat-card orange">
          <span className="stat-icon">📦</span>
          <div>
            <h3>{stats?.totalOrders || 0}</h3>
            <p>إجمالي الطلبات</p>
          </div>
        </div>
        <div className="stat-card purple">
          <span className="stat-icon">💰</span>
          <div>
            <h3>{stats?.totalRevenue?.toFixed(0) || 0} ج.م</h3>
            <p>إجمالي الإيرادات</p>
          </div>
        </div>
      </div>

      <div className="dashboard-row">
        <div className="card">
          <h3>الطلبات حسب الحالة</h3>
          <div className="status-list">
            {stats?.ordersByStatus?.map((s) => (
              <div key={s._id} className="status-item">
                <span className={`status-badge ${s._id}`}>{getStatusLabel(s._id)}</span>
                <span className="status-count">{s.count}</span>
              </div>
            ))}
          </div>
        </div>

        <div className="card">
          <h3>الإيرادات اليومية (آخر 30 يوم)</h3>
          <ResponsiveContainer width="100%" height={250}>
            <BarChart data={reports?.dailyRevenue || []}>
              <CartesianGrid strokeDasharray="3 3" />
              <XAxis dataKey="_id" tick={{ fontSize: 11 }} />
              <YAxis />
              <Tooltip />
              <Bar dataKey="revenue" fill="#2196F3" radius={[4, 4, 0, 0]} />
            </BarChart>
          </ResponsiveContainer>
        </div>
      </div>

      <div className="dashboard-row">
        <div className="card">
          <h3>أفضل الخدمات</h3>
          <table className="table">
            <thead>
              <tr><th>الخدمة</th><th>عدد الطلبات</th><th>الإيرادات</th></tr>
            </thead>
            <tbody>
              {reports?.topServices?.map((s, i) => (
                <tr key={i}>
                  <td>{s.name}</td>
                  <td>{s.count}</td>
                  <td>{s.revenue?.toFixed(0)} ج.م</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        <div className="card">
          <h3>أفضل العمال</h3>
          <table className="table">
            <thead>
              <tr><th>العامل</th><th>الطلبات</th><th>الأرباح</th></tr>
            </thead>
            <tbody>
              {reports?.topWorkers?.map((w, i) => (
                <tr key={i}>
                  <td>{w.name}</td>
                  <td>{w.completedOrders}</td>
                  <td>{w.earnings?.toFixed(0)} ج.م</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      <div className="card">
        <h3>العمال المعلقون</h3>
        <p>{stats?.pendingWorkers || 0} عامل بانتظار الموافقة</p>
      </div>
    </div>
  );
}

function getStatusLabel(status) {
  const map = {
    pending: 'معلق', accepted: 'مقبول', on_the_way: 'في الطريق',
    arrived: 'وصل', in_progress: 'جاري التنفيذ',
    completed: 'مكتمل', cancelled: 'ملغي',
  };
  return map[status] || status;
}
